'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { getMetricTooltipLangKey } from '../../utils/metricsTooltips';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_KEY = 'components.revenueAttributionCard.limitedAccess';
const langKey = key => `${BASE_KEY}.${key}`;
export default function MetricLabelLimitedAccess({
  metric,
  learnMoreUrl,
  screen
}) {
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey(`metricLabel.${metric}`)
    }), /*#__PURE__*/_jsx(HelpIcon, {
      paddingInlineStart: "200",
      color: "icon-core-subtle",
      size: "small",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: getMetricTooltipLangKey({
            key: metric,
            screen,
            baseKey: `${BASE_KEY}.metricLabel.tooltips`
          })
        }), learnMoreUrl && /*#__PURE__*/_jsx(Link, {
          href: learnMoreUrl,
          external: true,
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('learnMore')
          })
        })]
      }),
      tooltipPlacement: "bottom"
    })]
  });
}
MetricLabelLimitedAccess.propTypes = {
  metric: PropTypes.string.isRequired,
  learnMoreUrl: PropTypes.string,
  screen: PropTypes.string.isRequired
};